import React, { useState } from 'react'
import { Button, Popover, Typography, Box, CircularProgress, Alert } from '@mui/material'
import { useGetLoginPageHtmlQuery } from '../../../../api/simulation/simulation'
import Github from '../../../../common/images/gitgub.jpg'
import GoogleMeet from '../../../../common/images/google_meet.jpg'

function LoginIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7 7.13193V6.61204C7 4.46614 7 3.3932 7.6896 2.79511C8.37919 2.19703 9.44136 2.34877 11.5657 2.65224L15.8485 3.26408C18.3047 3.61495 19.5327 3.79039 20.2664 4.63628C21 5.48217 21 6.72271 21 9.20377V14.7962C21 17.2773 21 18.5178 20.2664 19.3637C19.5327 20.2096 18.3047 20.385 15.8485 20.7359L11.5657 21.3478C9.44136 21.6512 8.37919 21.803 7.6896 21.2049C7 20.6068 7 19.5339 7 17.388V17.066'
        stroke='#6123FF'
      />
      <path
        d='M16 12L16.3904 11.6877L16.6403 12L16.3904 12.3123L16 12ZM4 12.5C3.72386 12.5 3.5 12.2761 3.5 12C3.5 11.7239 3.72386 11.5 4 11.5V12.5ZM12.3904 6.68765L16.3904 11.6877L15.6096 12.3123L11.6096 7.31235L12.3904 6.68765ZM16.3904 12.3123L12.3904 17.3123L11.6096 16.6877L15.6096 11.6877L16.3904 12.3123ZM16 12.5H4V11.5H16V12.5Z'
        fill='#6123FF'
      />
    </svg>
  )
}

export default function LoginPagePopover({ name, loginPage }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const { data: html, isLoading, error } = useGetLoginPageHtmlQuery({ loginPage })

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined
  const handleButtonClick = event => {
    setAnchorEl(event?.currentTarget)
  }

  return (
    <div>
      <Button
        startIcon={<LoginIcon />}
        sx={{
          fontFamily: 'Plus Jakarta Sans',
          color: '#6123FF',
          textTransform: 'none'
        }}
        aria-describedby={id}
        variant='text'
        onClick={handleButtonClick}
      >
        {name}
      </Button>
      <Popover
        sx={{
          '.MuiPaper-root': {
            maxHeight: '70px'
          },
          '.MuiBackdrop-root': {
            background: '#00000070'
          }
        }}
        id={id}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert sx={{ '&.MuiAlert-root': { backgroundColor: '#0049FF' } }} variant={'filled'} severity='info'>
          This is a visual example. The login page will automatically adapt to user selected language during the
          phishing simulation.
        </Alert>
      </Popover>
      <Popover
        sx={{
          '.MuiPaper-root': {
            maxHeight: 'calc(100% - 100px)'
          }
        }}
        id={id}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Box sx={{ padding: 2 }}>
          {error ? (
            <Typography variant='h6' color='error'>
              Sorry, the content failed to load.
            </Typography>
          ) : isLoading ? (
            <CircularProgress />
          ) : loginPage === 'GITHUB' || loginPage === 'GOOGLE_MEET' ? (
            <img
              src={loginPage === 'GITHUB' ? Github : GoogleMeet}
              alt={`${loginPage} login`}
              width={1200}
              height={750}
            />
          ) : (
            <Box sx={{ position: 'relative', width: '1200px', height: '800px' }}>
              <iframe
                allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen'
                loading='lazy'
                width='1200'
                height='800'
                srcDoc={html?.body}
                sandbox='allow-same-origin allow-popups allow-forms allow-scripts'
              />
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'transparent',
                  zIndex: 1
                }}
              />
            </Box>
          )}
        </Box>
      </Popover>
    </div>
  )
}
